import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const dayjs = require('dayjs');
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');
const advancedFormat = require('dayjs/plugin/advancedFormat');

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

const Header = ({ event, user, ref }) => {
    return (
        <header className="registration__header" ref={ref}>
            <div className="container">
                <strong className="caps">Registration for:</strong>
                <h2 className="registration__eventTitle">{event?.title}</h2>
                <ul className="registration__eventDetails grid -col3">
                    <li className="grid__cell">
                        <strong className="caps">When:</strong>
                        <span className="registration__details">
                            {event?.startDate &&
                                dayjs
                                    .tz(event.startDate.date, event.virtual ? user.timezone : event.startDate.timezone)
                                    .format('MMMM D, YYYY h:mmA z')}
                        </span>
                    </li>

                    <li className="grid__cell">
                        <strong className="caps">Where:</strong>
                        <span className="registration__details">
                            {!event?.venue && !event?.city && <span>{event?.location}</span>}
                            {(!!event?.venue || !!event?.city) && (
                                <>
                                    <span style={{ display: 'inline-block' }}>{event?.venue}</span>
                                    <span>{event?.city}</span>
                                </>
                            )}
                        </span>
                    </li>

                    {!!event?.host && (
                        <li className="grid__cell">
                            <strong className="caps">Host/Primary Sponsor: </strong>
                            <span className="registration__details">{event?.host}</span>
                        </li>
                    )}
                </ul>
            </div>
        </header>
    );
};

Header.propTypes = {
    event: PropTypes.object,
    user: PropTypes.object,
    ref: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
};

export default forwardRef((props, ref) => Header({ ...props, ref}));
